/**
 * Class to store a value and a unit.
 */
export class Value {
  /**
   * @type {number}
   */
  value;
  /**
   * @type {string|undefined}
   */
  unit;
}
